import PageHeader from "../components/PageHeader";
import BlogDetailCotent from '../components/Blog-Detail-Content'

const Blog = () => {

    return (
        <>
            <PageHeader pagetitle="Blog Detail" breadcrumbMenu="Home" breadcrumbMenuActive="Blog Detail" image="/images/blog-banner.jpg" />
            <BlogDetailCotent />
        </>
    )
}

export default Blog